<a class="skip-link" href="#main_content">Skip to content</a>
<h1 class="sr-only" id="h1">Noteable notebook selector</h1>
<!-- Cookie Modal -->
<section id="cookie-modal" class="modal" aria-labelledby="cookie-popup-heading">
  <div class="modal-content">
    <header>
      <h2 id="cookie-popup-heading">Cookies on the Noteable website</h2>
    </header>
    <div class="modal-body">
      <p>
        We use cookies for security purposes, remembering your preferences and to analyse site traffic in order to
        improve your experience using the service. This includes anonymised Google Analytics data. We won't share your
        data with anyone else.
        <br /><br />
        For more information please see our
        <a href="/cookie-policy">Cookies Policy</a> page.
      </p>
    </div>
    <footer>
      <button id="refuse-cookies-btn" class="button-main">Use only Necessary Cookies</button>
      <button id="accept-cookies-btn" class="button-main">I'm OK with that</button>
    </footer>
  </div>
</section>
<nav class="topnav" id="navMenu" aria-label="Main Menu">
  <a href="javascript:void(0);" class="icon" (click)="hamburgerToggle()">&#9776;</a>
  <ul>
    <li><a href="/">About Noteable</a></li>
    <li><a href="/resources/">Resources</a></li>
    <li><a href="https://noteable.statuspage.io">Status</a></li>
    <li><a href="/usage-reporting">Usage Reporting</a></li>
    <li><a href="/logout">Log out</a></li>
    <li>
      <button
        id="contactDropdown"
        class="dropdown"
        tabindex="0"
        aria-label="Contact Us Dropdown Menu"
        (mouseover)="setExpanded('true')"
        (mouseout)="setExpanded('false')"
        (focus)="setExpanded('true')"
        (focusout)="setExpanded('false')">
        <span id="contactUsButton">Contact Us ▼</span>
        <ul class="dropdown-content">
          <li><a class="dropdownOption" href="/contact-us/" tabindex="0">Contact Us</a></li>
          <li><a class="dropdownOption" href="/try-noteable/" tabindex="0">Request a Trial</a></li>
          <li><a class="dropdownOption" href="/report-a-problem/" tabindex="0">Report a Problem</a></li>
          <li><a class="dropdownOption" href="/subscribe-newsletter/" tabindex="0">Subscribe to Newsletter</a></li>
        </ul>
      </button>
    </li>
  </ul>
</nav>

<section class="main-nav-wrapper" aria-label="Site logo">
  <img src="/images/logo_noteable.svg" class="header-logo" alt="The Noteable logo" />
</section>
